import { render, staticRenderFns } from "./ViewOrganizationUserLogs.vue?vue&type=template&id=17f01560&scoped=true"
import script from "./ViewOrganizationUserLogs.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationUserLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f01560",
  null
  
)

export default component.exports